// Strona kalkulatora klejenia - zintegrowana z nowym modułem adhesives
import React from 'react';
import AdhesivesPage from '../features/adhesives/AdhesivesPage';

const GluingCalculatorPage: React.FC = () => {
  // Używamy nowego modułu adhesives zamiast starej implementacji
  return <AdhesivesPage />;
};

export default GluingCalculatorPage;
